import React from "react";

function AboutUs() {
  return (
    <div style={{ padding: "24px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", color: "#333" }}>
      <h1 style={{ textAlign: "center", color: "#1a237e" }}>About Us</h1>
      <p>
        Welcome to <strong>KnowledgeCheck</strong>, your go-to platform for enhancing your knowledge and practicing through engaging challenges. 
        Our mission is to provide a fun and interactive way for users to test their skills, learn new concepts, and grow their expertise in various domains.
      </p>
      <p>
        At KnowledgeCheck, we strive to ensure that all questions and answers are accurate and relevant. However, we acknowledge that occasional errors may occur. 
        If you come across any discrepancies, please feel free to reach out to us. Your feedback is invaluable in helping us improve and provide a better experience for all users.
      </p>
      <p>
        For any queries, suggestions, or corrections, please contact us at: 
        <a href="mailto:support@knowledgecheck.in" style={{ color: "#007BFF", textDecoration: "none" }}> support@knowledgecheck.in</a>
      </p>
      <p>
        Thank you for choosing KnowledgeCheck. We hope you enjoy using our platform and find it valuable in your journey of learning and self-improvement.
      </p>
    </div>
  );
}

export default AboutUs;